module.exports = __webpack_public_path__ + "img/cpf.83b0470f.svg";